import { ComposedChart, Cell, Bar, XAxis, YAxis } from 'recharts'
import s from './DealsChart.scss'
import { getCurrency } from 'utils/authService'
import pluralize from 'pluralize'
import { toDealsChartData } from './serializers'

const DealsChart = ({ pipeline, chartWidth, chartHeight }) => {
  if (!pipeline) {
    return <span>No data available for graph</span>
  }

  const data = toDealsChartData(Object.values(pipeline.info))

  const getLabelX = (x, width) => x + width / 2

  const maxData = data.reduce((prev, current) => (prev.value > current.value ? prev : current))
  const maxValue = maxData ? maxData.value : 0

  const shouldRenderTooltip = value => maxValue / value > 3

  const renderLabel = item => {
    const { x, y, width, height, index, value } = item
    const count = data[index].count
    const fill = '#fff'
    const labelX = getLabelX(x, width)
    return value ? (
      shouldRenderTooltip(value) ? (
        <path
          fill={data[index].color}
          width={width}
          height={height}
          color={data[index].color}
          x={x}
          y={y}
          d={`M ${x},${y} h ${width} v ${height} h -${width} Z`}
        >
          <title>
            {`$${value.toLocaleString()}`} - {pluralize('opportunity', count, true)}
          </title>
        </path>
      ) : (
        <text
          x={labelX}
          y={y}
          width={width}
          height={height}
          fill={fill}
          className={s.chartLabel}
          textAnchor="middle"
        >
          <tspan x={labelX} dy="1em" width={width} alt="aaaaa">
            {`${getCurrency().symbol}${value.toLocaleString()}`}
          </tspan>
          <tspan x={labelX} dy="1.5em" width={width}>
            {pluralize('opportunity', count, true)}
          </tspan>
        </text>
      )
    ) : (
      ''
    )
  }

  return (
    <ComposedChart
      layout="vertical"
      width={chartWidth}
      height={chartHeight}
      data={data}
      margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
      className={s.chartContainer}
      key={Math.random()}
    >
      <XAxis type="number" />
      <YAxis dataKey="name" type="category" />
      <Bar dataKey="value" fill="red" label={renderLabel}>
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={data[index % 10].color} />
        ))}
      </Bar>
    </ComposedChart>
  )
}

export default DealsChart
